import React from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { useDriverDocs } from "@/components/price/DriverDocsCard";

// Bandeau accueil conducteur : motif du blocage / déclaration / document à renouveler bientôt.
export default function DriverDocsBanner({ onOpen }) {
  const { data } = useDriverDocs();
  if (!data) return null;
  const soon = data.groups.find((g) => g.status === "renewal_soon" && !g.renewal_sent.length);
  const msg = data.can_drive_reason || (soon ? `${soon.label} à renouveler avant le ${new Date(`${soon.due}T12:00:00`).toLocaleDateString("fr-FR")}` : null);
  if (!msg) return null;
  const blocking = !!data.can_drive_reason;
  return (
    <button type="button" onClick={onOpen} data-testid="driver-docs-banner"
      className={`street-press mt-4 flex w-full items-center gap-3 rounded-2xl p-3 text-left street-border-thin street-shadow-sm ${blocking ? "bg-red-100 text-red-900" : "bg-amber-100 text-amber-900"}`}>
      <AlertTriangle className="h-5 w-5 flex-none" strokeWidth={2.75} />
      <span className="min-w-0 flex-1 text-[13px] font-black">{msg}</span>
      <ChevronRight className="h-4 w-4 flex-none" strokeWidth={3} />
    </button>
  );
}
